import { Component, input, output } from "@angular/core";
import { IAllSearch } from "../../../interfaces";
import { Dialog } from "@angular/cdk/dialog";
import DialogService from "../../services/dialog.service";
import DataService from "../../services/data.service";
import ExceptionService from "../../services/exception.service";
import { Router, RouterLink } from "@angular/router";
import { NgClass } from "@angular/common";
import { MatIcon } from "@angular/material/icon";
import { MatMiniFabButton } from "@angular/material/button";
import { MatTooltip } from "@angular/material/tooltip";
import { FaIconComponent } from "@fortawesome/angular-fontawesome";
import { MatMenuTrigger, MatMenu, MatMenuItem } from "@angular/material/menu";
import { HighlightDirective } from "../../directives/highlight.directive";
import { MatChip, MatChipSet } from "@angular/material/chips";
import { Constants } from "../../../../constants";
import { HideForRolesDirective } from "../../directives/hideForRoles.directive";

@Component({
    selector: "order-result",
    templateUrl: "./order-result.component.html",
    styleUrl: "./order-result.component.scss",
    imports: [
        NgClass,
        MatIcon,
        MatMiniFabButton,
        MatTooltip,
        FaIconComponent,
        RouterLink,
        MatMenuTrigger,
        HighlightDirective,
        MatChipSet,
        MatChip,
        MatMenu,
        MatMenuItem,
        HideForRolesDirective,
    ],
})
export class OrderResultComponent {
    readonly CustomerRoleString = Constants.roles.Customer;
    readonly BrokerRoleString = Constants.roles.Broker;
    item = input.required<IAllSearch>();
    searchTerm = input.required<string>();
    shortcutClick = output<void>();

    constructor(
        private router: Router,
        private dialog: Dialog,
        private dialogService: DialogService,
        private dataService: DataService,
        private exceptionService: ExceptionService
    ) {}

    statusColor(s: string) {
        return `status-${s.replace(" - ", "-").replace(" ", "").toLowerCase()}`;
    }

    get primaryId(): string {
        return `#${this.item().ID}`;
    }

    get backgroundClass(): string {
        return "";
    }

    formatDate(dateString?: string): string {
        if (!dateString) return "N/A";
        try {
            const date = new Date(dateString);
            return date.toLocaleDateString();
        } catch {
            return dateString;
        }
    }

    get metaLine(): string {
        return `Agent ${this.item().AgentNumber} • Load #${this.item().LoadNumber}`;
    }

    copyButton() {
        this.cloneOrder(this.item().ID);
    }

    customCopyButton() {
        this.customCloneOrder(this.item().ID);
    }

    loadButton() {
        this.shortcutClick.emit();
    }

    loadTrackButton() {
        this.shortcutClick.emit();
    }

    cloneOrder(id: number) {
        this.dialogService
            .mdConfirm("Confirm", "Are you sure you would like to copy this order?", "Yes", "No")
            .afterClosed()
            .subscribe((result) => {
                if (result) {
                    //  If they choose 'YES'
                    this.dataService
                        .post(`api/CustomerOrder/Clone/${id}`, null)
                        .then((result) => {
                            this.router.navigate(["/dispatch/order/maintenance", result]);
                        })
                        .catch((error) => this.exceptionService.handleException(error));
                } else {
                    // If they choose 'NO'
                    return;
                }
            });
    }

    customCloneOrder(id: number) {
        import("../../../Dispatch/Order/order-custom-copy-dialog/order-custom-copy-dialog.component").then(
            ({ OrderCustomCopyDialogComponent }) => {
                this.dialog.open(OrderCustomCopyDialogComponent, {
                    width: "900px",
                    data: {
                        orderID: id,
                    },
                });
            }
        );
    }
}
